import { Fragment } from 'react'
import { Button } from './Button'

export function Pagination({
  page,
  limit,
  total,
  onPageChange,
  onLimitChange,
}: {
  page: number
  limit: number
  total: number
  onPageChange: (page: number) => void
  onLimitChange: (limit: number) => void
}) {
  const totalPages = Math.max(1, Math.ceil(total / limit))
  const start = total === 0 ? 0 : (page - 1) * limit + 1
  const end = Math.min(total, page * limit)
  const pages = Array.from(new Set([
    1,
    Math.max(1, page - 1),
    page,
    Math.min(totalPages, page + 1),
    totalPages,
  ])).filter(item => item >= 1 && item <= totalPages)

  return (
    <div className="flex flex-wrap items-center justify-between gap-3 border-t border-stone-100 px-4 py-3 text-sm text-stone-500">
      <span>Showing {start}-{end} of {total}</span>
      <div className="flex flex-wrap items-center gap-2">
        <label className="flex items-center gap-2 text-xs font-semibold text-stone-500">
          Rows
          <select
            className="rounded-lg border border-stone-200 bg-white px-2 py-1.5 text-xs outline-none focus:border-mango-orange"
            onChange={(event) => onLimitChange(Number(event.target.value))}
            value={limit}
          >
            <option>10</option>
            <option>20</option>
            <option>50</option>
          </select>
        </label>
        <Button disabled={page <= 1} onClick={() => onPageChange(page - 1)} variant="ghost">Prev</Button>
        {pages.map((pageNumber, index) => (
          <Fragment key={pageNumber}>
            {index > 0 && pageNumber - pages[index - 1] > 1 ? <span className="px-1 text-stone-400">...</span> : null}
            <button
              className={pageNumber === page ? 'grid h-9 w-9 place-items-center rounded-lg bg-mango-orange text-sm font-bold text-white' : 'grid h-9 w-9 place-items-center rounded-lg border border-stone-200 bg-white text-sm font-semibold text-stone-600 hover:bg-stone-50'}
              onClick={() => onPageChange(pageNumber)}
              type="button"
            >
              {pageNumber}
            </button>
          </Fragment>
        ))}
        <Button disabled={page >= totalPages} onClick={() => onPageChange(page + 1)} variant="soft">Next</Button>
      </div>
    </div>
  )
}
